import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "px-6 py-2"
};
const _hoisted_2 = {
  key: 1,
  class: "mt-8 text-gray-700",
  "data-cy": "firm-info-load-failed"
};
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  class: "flex py-2 tw space-x-2"
};
const _hoisted_5 = {
  class: "w-3/12"
};
const _hoisted_6 = {
  class: "block text-error"
};
const _hoisted_7 = {
  class: "w-3/12"
};
const _hoisted_8 = {
  class: "py-2"
};
const _hoisted_9 = {
  class: "w-6/12"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "py-2 w-6/12"
};
const _hoisted_12 = {
  class: "flex"
};
const _hoisted_13 = {
  class: "px-2 mt-4"
};
const _hoisted_14 = {
  class: "flex space-x-2 py-2"
};
const _hoisted_15 = {
  class: "w-3/6"
};
const _hoisted_16 = {
  class: "w-3/6"
};
const _hoisted_17 = {
  class: "py-2 w-6/12"
};
const _hoisted_18 = {
  class: "flex"
};
const _hoisted_19 = {
  class: "px-2 mt-4"
};
const _hoisted_20 = {
  class: "flex space-x-2 py-2"
};
const _hoisted_21 = {
  class: "w-3/6"
};
const _hoisted_22 = {
  class: "w-3/6"
};
const _hoisted_23 = {
  class: "py-2 w-6/12"
};
const _hoisted_24 = {
  class: "flex"
};
const _hoisted_25 = {
  class: "px-2 mt-4"
};
const _hoisted_26 = {
  key: 1,
  class: "py-2"
};
const _hoisted_27 = {
  class: "grid grid-cols-3 gap-4"
};
const _hoisted_28 = {
  key: 0,
  class: "grid grid-cols-3 gap-4"
};
const _hoisted_29 = {
  class: "py-2"
};
const _hoisted_30 = {
  class: "grid grid-cols-1 lg:grid-cols-2 gap-6 py-2"
};
const _hoisted_31 = {
  class: "border border-outline-variant border-opacity-100 rounded overflow-hidden"
};
const _hoisted_32 = {
  class: "px-4 py-4 flex flex-col gap-3"
};
const _hoisted_33 = {
  class: "border border-outline-variant border-opacity-100 rounded overflow-hidden"
};
const _hoisted_34 = {
  class: "px-4 py-4 flex flex-col gap-3"
};
const _hoisted_35 = {
  key: 0,
  class: "px-4 py-3 border-t border-outline-variant border-opacity-100"
};
const _hoisted_36 = {
  class: "flex items-center border border-outline-variant border-opacity-100 rounded px-4 py-3 mt-5"
};
import { ref, computed, onMounted, reactive } from 'vue';
import axios from 'axios';
import { storeToRefs } from 'pinia';

// from project
import LlTooltip from '@/components/LlTooltip.vue';
import ProductNotice from '@/components/ProductNotice.vue';
import MainHeader from '@/components/MainHeader.vue';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import RouteService from '@/services/RouteService';
import DownloadService from '@/services/DownloadService';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import Loader from '@/components/Loader.vue';
import LlTextarea from '@/components/LlTextarea.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';

// from services
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
export default {
  __name: 'CompanyInfo',
  props: {
    rootScope: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    leanLawAuth: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    // from framework
    const props = __props;
    const companyInfoState = reactive({
      loading: true,
      options: [0.01, 0.1, 0.25, 0.5],
      businesses: [{
        id: 'law',
        label: 'Law Firm'
      }, {
        id: 'consult',
        label: 'Consulting'
      }, {
        id: 'accountant',
        label: 'Accounting'
      }],
      unsaved: false,
      saving: false,
      loadFailed: false
    });
    const infoForm = ref({});
    const {
      features,
      terms
    } = storeToRefs(useMeStore());
    const {
      companySettings,
      name
    } = storeToRefs(useCompanyStore());
    const meStore = useMeStore();
    const companyStore = useCompanyStore();
    const somethingChanged = computed(() => JSON.stringify(infoForm.value) !== JSON.stringify(setForm()));
    const incrementOptions = computed(() => companyInfoState.options.map(id => ({
      id,
      label: `${id} hours`
    })));
    function setForm() {
      const {
        business,
        labels,
        requireOriginating,
        requireFixedFeeUser,
        requireExpenseUser,
        timeEntryIncrement,
        enforceRounding,
        adjustments,
        contactInformation,
        ledes,
        keepTimeUnlockedAfterBilling
      } = companySettings.value;
      return {
        name: name.value,
        settings: {
          business: companyInfoState.businesses.find(b => b.id === (business || '')) || companyInfoState.businesses[0],
          labels: {
            custom1: labels?.custom1 || '',
            custom2: labels?.custom2 || '',
            customFlag: labels?.customFlag || ''
          },
          requireOriginating: requireOriginating || false,
          requireFixedFeeUser: requireFixedFeeUser || false,
          requireExpenseUser: requireExpenseUser || false,
          timeEntryIncrement: timeEntryIncrement || '0.1',
          enforceRounding: enforceRounding || false,
          adjustments: adjustments || false,
          contactInformation: contactInformation || null,
          ledes: JSON.parse(JSON.stringify(ledes || {
            address: {},
            billingContact: {}
          })),
          // The whole setting lives behind fixedFeeTimeLock: an unflagged firm's form
          // has no such key, so its save is byte-identical to before this shipped and
          // the sparse PUT leaves any stored value alone. Null is Off (BR-001) — every
          // firm reads null until it sets this, so `=== true` never opts anyone in.
          ...(features.value.fixedFeeTimeLock ? {
            keepTimeUnlockedAfterBilling: keepTimeUnlockedAfterBilling === true
          } : {})
        }
      };
    }
    async function getContactInformation() {
      if (companySettings.value.contactInformation == null) {
        try {
          const response = await axios.get('companies/qbo-contact-info');
          const qboAddress = response.data.contactInfo || '';

          // Auto-save the QBO address so it persists without requiring a manual save.
          // This only fires when contactInformation is null (never been set).
          if (qboAddress) {
            await companyStore.updateMyCompany({
              settings: {
                contactInformation: qboAddress
              }
            });
          }
        } catch {
          // QBO not connected or save failed — leave contactInformation as-is
        }
      }
    }
    async function download() {
      new DownloadService(props.leanLawAuth).get('/v1/export');
    }
    const {
      handleError,
      handleSuccess
    } = useSnackbarHandler();
    function update() {
      companyInfoState.saving = true;
      companyInfoState.unsaved = false;
      companyStore.updateMyCompany({
        ...infoForm.value,
        settings: {
          ...infoForm.value.settings,
          business: infoForm.value.settings.business.id,
          // add ledes only if features.ledesXml2 is true
          ledes: features.value.ledesXml2 ? infoForm.value.settings.ledes : null
        }
      }).then(() => {
        companyInfoState.saving = false;
        cancel();
        handleSuccess('Firm info saved');
        // /me holds its own copy of company.settings, which other screens read —
        // without this refetch a setting saved here looks ignored until a reload.
        // Not awaited: the save is done and getMe handles its own errors.
        meStore.getMe(true);
      }).catch(error => {
        companyInfoState.saving = false;
        handleError(error);
      });
    }
    function cancel() {
      infoForm.value = setForm();
    }
    onMounted(async () => {
      companyInfoState.loading = true;
      const [, settings] = await Promise.all([meStore.getMe(), companyStore.loadMyCompany()]);

      // loadMyCompany resolves null on failure, having toasted. Building the form
      // from nothing would show firm-wide defaults as if they were saved values,
      // and the next save would write them over the real ones.
      if (settings === null) {
        companyInfoState.loadFailed = true;
        companyInfoState.loading = false;
        return;
      }
      await getContactInformation();
      infoForm.value = setForm();
      const deactivate = new RouteService(props).rootScopeChange().$on('$stateChangeStart', event => {
        if (somethingChanged.value) {
          companyInfoState.unsaved = true;
          setTimeout(() => {
            companyInfoState.unsaved = false;
          }, 4000);
          event.preventDefault();
        } else {
          deactivate();
        }
      });
      companyInfoState.loading = false;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(MainHeader, {
        content: "Firm Info"
      }), companyInfoState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: "Firm Info",
        class: "mt-32"
      })) : companyInfoState.loadFailed ? (_openBlock(), _createElementBlock("div", _hoisted_2, " We couldn't load your firm info. Refresh the page to try again. ")) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlTextField, {
        modelValue: infoForm.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => infoForm.value.name = $event),
        label: "Name"
      }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("b", _hoisted_6, "Firm name must be provided.", 512), [[_vShow, !infoForm.value.name?.length]])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("label", null, [_cache[30] || (_cache[30] = _createTextVNode(" Type of Business ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode(" This determines what certain things are named in the UI, Law Firms have 'Matters' and Consulting have 'Projects' ", -1)]))]),
        _: 1
      })]), _createVNode(LlSelect, {
        modelValue: infoForm.value.settings.business,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => infoForm.value.settings.business = $event),
        items: companyInfoState.businesses,
        "item-title": "label",
        "item-value": "id",
        density: "compact",
        "return-object": "",
        placeholder: "Type of Business",
        variant: "outlined",
        "hide-details": "true",
        clearable: "",
        labelClass: "text-sm at-choose-client remove-outline",
        isAutocomplete: ""
      }, null, 8, ["modelValue", "items"])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(LlTextarea, {
        label: "Invoice PDF Firm Address",
        "hide-details": "true",
        info: "This information will appear on invoices generated from LeanLaw. Leave blank if you don't want a firm address/contact information on the invoice.",
        modelValue: infoForm.value.settings.contactInformation,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => infoForm.value.settings.contactInformation = $event)
      }, null, 8, ["modelValue"])])]), _unref(features).ledesXml2 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[32] || (_cache[32] = _createElementVNode("h3", null, "Firm LEDES Address", -1)), _createElementVNode("div", _hoisted_13, [_createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("These fields will correspond to the Firm Address Info segment of LEDES XML 2.0 and LEDES 2000.", -1)]))]),
        _: 1
      })])]), _createElementVNode("div", null, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.line1,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => infoForm.value.settings.ledes.address.line1 = $event),
        label: "Address line 1"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.line2,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => infoForm.value.settings.ledes.address.line2 = $event),
        label: "Address line 2"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.line3,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => infoForm.value.settings.ledes.address.line3 = $event),
        label: "Address line 3"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.city,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => infoForm.value.settings.ledes.address.city = $event),
        label: "City"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.zip,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => infoForm.value.settings.ledes.address.zip = $event),
        label: "Zip/Postal Code"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.phone,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => infoForm.value.settings.ledes.address.phone = $event),
        label: "Phone"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_16, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.state,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => infoForm.value.settings.ledes.address.state = $event),
        label: "State/Province"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.country,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => infoForm.value.settings.ledes.address.country = $event),
        label: "Country"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.address.fax,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => infoForm.value.settings.ledes.address.fax = $event),
        label: "Fax"
      }, null, 8, ["modelValue"])])])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[34] || (_cache[34] = _createElementVNode("h3", null, "Law Firm Billing Contact", -1)), _createElementVNode("div", _hoisted_19, [_createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("This is the firm billing contact used in LEDES XML 2.0 and LEDES 2000 invoices", -1)]))]),
        _: 1
      })])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.billingContact.firstName,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => infoForm.value.settings.ledes.billingContact.firstName = $event),
        label: "First Name"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.billingContact.phone,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => infoForm.value.settings.ledes.billingContact.phone = $event),
        label: "Contact Phone"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_22, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.billingContact.lastName,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => infoForm.value.settings.ledes.billingContact.lastName = $event),
        label: "Last Name"
      }, null, 8, ["modelValue"]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.billingContact.fax,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => infoForm.value.settings.ledes.billingContact.fax = $event),
        label: "Contact Fax"
      }, null, 8, ["modelValue"])])]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.billingContact.email,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => infoForm.value.settings.ledes.billingContact.email = $event),
        label: "Contact Email"
      }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_cache[36] || (_cache[36] = _createElementVNode("h3", null, "Law Firm Website", -1)), _createElementVNode("div", _hoisted_25, [_createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("Your firm's website. Maps to 'firm_URL' in LEDES XML 2.0.", -1)]))]),
        _: 1
      })])]), _createVNode(LlTextField, {
        modelValue: infoForm.value.settings.ledes.lawFirmWebsite,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => infoForm.value.settings.ledes.lawFirmWebsite = $event),
        label: "Website"
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), _cache[41] || (_cache[41] = _createElementVNode("h3", null, "Custom Fields", -1)), _createVNode(ProductNotice, {
        state: __props.state,
        label: 'Custom fields are',
        product: 'customFieldMapping'
      }, null, 8, ["state"]), _unref(features).customFieldMapping ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.labels.custom1,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => infoForm.value.settings.labels.custom1 = $event),
        label: `Custom ${_unref(terms).Matter} Field Name 1`
      }, null, 8, ["modelValue", "label"])]), _createElementVNode("div", null, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.labels.custom2,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => infoForm.value.settings.labels.custom2 = $event),
        label: `Custom ${_unref(terms).Matter} Field Name 2`
      }, null, 8, ["modelValue", "label"])])]), _unref(features).customFieldMapping ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(LlTextField, {
        modelValue: infoForm.value.settings.labels.customFlag,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => infoForm.value.settings.labels.customFlag = $event),
        label: "Custom Checkbox Name",
        placeholder: "Checkbox Name",
        info: "Enable custom checkbox on time, expense, and fixed fee entries.\n                The name will appear on lists and reports. This can be used for\n                special reporting."
      }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _cache[42] || (_cache[42] = _createElementVNode("h3", null, "Options", -1)), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_cache[37] || (_cache[37] = _createElementVNode("div", {
        class: "px-4 py-3 bg-gray-50 border-b border-outline-variant border-opacity-100 font-weight-medium"
      }, " Required Fields ", -1)), _createElementVNode("div", _hoisted_32, [_createVNode(LlCheckbox, {
        label: `Require Originating ${_unref(terms).Lead} on ${_unref(terms).matter} creation`,
        modelValue: infoForm.value.settings.requireOriginating,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => infoForm.value.settings.requireOriginating = $event)
      }, null, 8, ["label", "modelValue"]), _createVNode(LlCheckbox, {
        label: "Require User on Fixed Fee",
        modelValue: infoForm.value.settings.requireFixedFeeUser,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => infoForm.value.settings.requireFixedFeeUser = $event)
      }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
        label: "Require User on Expenses",
        modelValue: infoForm.value.settings.requireExpenseUser,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => infoForm.value.settings.requireExpenseUser = $event)
      }, null, 8, ["modelValue"]), _unref(features).fixedFeeTimeLock ? (_openBlock(), _createBlock(LlCheckbox, {
        key: 0,
        label: "Keep time unlocked on fixed fees after billing",
        info: "When on, billed fees stay unlocked for time tracking until time is manually locked. Default: off.",
        modelValue: infoForm.value.settings.keepTimeUnlockedAfterBilling,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => infoForm.value.settings.keepTimeUnlockedAfterBilling = $event),
        "data-cy": "keep-time-unlocked-after-billing"
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_33, [_cache[38] || (_cache[38] = _createElementVNode("div", {
        class: "px-4 py-3 bg-gray-50 border-b border-outline-variant border-opacity-100 font-weight-medium"
      }, " Time Entries ", -1)), _createElementVNode("div", _hoisted_34, [_createVNode(LlSelect, {
        modelValue: infoForm.value.settings.timeEntryIncrement,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => infoForm.value.settings.timeEntryIncrement = $event),
        items: incrementOptions.value,
        "return-object": false,
        clearable: false,
        "hide-details": true,
        label: "Default Time Entry Increment",
        info: "Determines in what increments time entries will round up for purposes of converting timers to time entries and other time entry creation.",
        "component-class": "w-40",
        "data-cy": "time-entry-increment"
      }, null, 8, ["modelValue", "items"]), _createVNode(LlCheckbox, {
        label: "Only accept time entries in multiples of the increment",
        info: "If enabled, users in your firm will not be able to save time entries unless entered in an increment of the Default Time Entry Increment.",
        modelValue: infoForm.value.settings.enforceRounding,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => infoForm.value.settings.enforceRounding = $event)
      }, null, 8, ["modelValue"]), _unref(features).writedown ? (_openBlock(), _createBlock(LlCheckbox, {
        key: 0,
        label: "Enable Write-down for Time Entries",
        info: "When enabled, allows partial or full write-down of time entries in Draft invoices, and tracks the adjustments in related reports.",
        modelValue: infoForm.value.settings.adjustments,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => infoForm.value.settings.adjustments = $event)
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]), !_unref(features).writedown ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createVNode(ProductNotice, {
        state: __props.state,
        label: 'Write-down of time entries (and related reports) are',
        product: 'writedown',
        trial: true
      }, null, 8, ["state"])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_36, [_cache[40] || (_cache[40] = _createElementVNode("div", {
        class: "flex-1 mr-4"
      }, [_createElementVNode("div", {
        class: "font-weight-medium"
      }, "Download Data"), _createElementVNode("div", {
        class: "text-sm text-grey-darken-1"
      }, " Downloads Clients, Matters, Rates, Time Entries, Expenses and Fixed Fees, as a zip. ")], -1)), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[28] || (_cache[28] = $event => download())
      }, {
        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode(" Download LeanLaw Data ", -1)]))]),
        _: 1
      })]), _createVNode(SettingsSaveBar, {
        somethingChanged: somethingChanged.value,
        saving: companyInfoState.saving,
        unsaved: companyInfoState.unsaved,
        onCancel: cancel,
        onUpdate: update
      }, null, 8, ["somethingChanged", "saving", "unsaved"])]))]);
    };
  }
};